export type AddToListsButtonState = "collection" | "wishlist" | "available";

export function addToListsButtonState(
  inCollection: boolean,
  inWishlist: boolean,
): AddToListsButtonState {
  if (inCollection) return "collection";
  if (inWishlist) return "wishlist";
  return "available";
}
